<template>
<div id="homePageContainer">
    <!-- How we organize our components within the template -->
    <!-- Sequence refers to the component order -->
    <div class="layout-section">
        <!-- We're just checking the sequence item here and rendering the right one -->
        <!-- We also pass in our models to their respective components -->

        <ASpotFullWidth :model="articles[0]" />

        <!-- Hide FirstTimeVisitorComponent if SSO user -->
        <FirstTimeVisitorComponent v-if="!userStore.isSSOLogin" />
        <div class="gray-background full-width">
            <HeaderElement :model="nthHeader(0)" class="cta-group-header text-center" />
            <CardsCarousel :cards="actionCards" type="Action" class="action-cards-carousel" />
        </div>

         

        <HeaderElement class="carousels-header" :model="nthHeader(1)" />
        <CardsCarousel :cards="nthArticleGroup(0)" type="Article" />

        <CardsCarousel :cards="nthArticleGroup(1)" type="Article" class="article-carousel-two" />

        <HeaderElement class="additional-resources-header" :model="nthHeader(2)" />

        <CardSection :model="additionalResources" />
        
       
    </div>
</div>
</template>

<script>
import {
    widgetConsts,
} from "@/constants.js";
import ASpotFullWidth from "@/components/ContentSite/ASpotFullWidth";
import HeaderElement from "@/components/ContentSite/HeaderElement";
import CardsCarousel from "@/components/ContentSite/sections/CardsCarousel.vue";
import CardSection from "@/components/ContentSite/sections/CardSection.vue";
import FirstTimeVisitorComponent from "@/components/ContentSite/FirstTimeVisitorComponent/FirstTimeVisitorComponent.vue";
import { useContentStore } from "@/stores/content.js";
import { useUserStore } from "@/stores/user.js";

export default {
    name: "HomePageLayout",
    setup() {
        const contentStore = useContentStore();
        const userStore = useUserStore();
        return { contentStore, userStore };
    },
    data() {
        return {
            headerElements: [],
            headers: [],
            additionalResources: [],
            actionCards: [],
            articles: [],
        };
    },
    components: {
        ASpotFullWidth,
        CardSection,
        CardsCarousel,
        HeaderElement,
        FirstTimeVisitorComponent
    },
    methods: {
        nthHeader(i) {
            return this.headers[i];
        },
        nthArticleGroup(i) {
            return this.articles.slice(3 * i, 3 * i + 3);
        },
        sortArticlesByDate() {
            this.articles.sort((a, b) => {
                if (a.PublishDateYear < b.PublishDateYear) {
                    return 1;
                } else if (a.PublishDateYear == b.PublishDateYear) {
                    if (a.PublishDateMonth < b.PublishDateMonth) {
                        return 1;
                    } else if (a.PublishDateMonth == b.PublishDateMonth) {
                        if (a.PublishDateDay < b.PublishDateDay) {
                            return 1;
                        }
                    }
                }

                return -1;
            });
        },
    },
    mounted() {
        // Local API call here to give us some 'mock' data. (Change later on)
        // Setup all your models you need to pass into your components here.

        // Sample experiment
        // this.runExperimentsForTrigger(experimentConsts.PAGE_ENTRY, this.$route.name);

        this.contentStore.getArticleWidgetsAsync({
            endpoint: this.$route.name,
        }).then((response) => {
            const result = response.data.Result;
            if (result) {
                result.forEach((widget) => {
                    const widgetType = widget.Type;
                    if (widgetType === widgetConsts.HEADER_ELEMENT_WIDGET) {
                        this.headers.push(widget.Model);
                    } else if (
                        widgetType === widgetConsts.ADDITIONAL_RESOURCE_CARD_WIDGET
                    ) {
                        this.additionalResources.push(widget.Model);
                    } else if (widgetType === widgetConsts.ACTION_CARD_WIDGET) {
                        let blurb = widget.Model.Blurb;
                        if (this.userStore.isSSOLogin && blurb) {
                            blurb = blurb.replace(/your policyholder/gi, "the policyholder");
                        }
                        widget.Model.Blurb = blurb;
                        this.actionCards.push(widget.Model);
                    }
                });
            }
        });

        this.contentStore.getArticleListAsync({blocking: true}).then((response) => {
            this.articles = response.data.Result.map((m) => m.Model);
            this.sortArticlesByDate();
        });
    },
};
</script>

<style lang="scss" scoped>
#homePageContainer {
    .layout-section {
        &> :not(.full-width),
        .full-width>*:not(.full-width) {
            max-width: $page-width-padded;
            margin: auto;
        }
    }

    .layout-section {
        &> :not(.full-width),
        .full-width>*:not(.full-width) {
            max-width: $page-width-padded;
            margin: auto;
        }

        h2 {
            text-align: center;
        }

        .gray-background {
            background-position: center top;
            background-repeat: no-repeat;
            background-size: cover;
            margin-bottom: $spacer-six;
        }
    }

    @include tablet {
        .article-carousel-two {
            padding-top: 45px;
        }

        .additional-resources-header {
            padding-top: $spacer-six;
        }

        .gray-background {
            background-image: linear-gradient(175deg,
                    rgba(255, 255, 255, 0),
                    rgba(255, 255, 255, 0) 150px,
                    $grayscale-seven 151px);

            padding-bottom: 40px;

            .action-cards-carousel {
                padding: $spacer-three $spacer-four;
            }
        }
    }

    @include wide-mobile {
        .layout-section {
            .gray-background {
                background-image: linear-gradient(175deg,
                        rgba(255, 255, 255, 0),
                        rgba(255, 255, 255, 0) 85px,
                        $grayscale-seven 86px);

                padding-bottom: $spacer-three;
            }

            .article-carousel-one {
                padding-top: $spacer-three;
            }

            .article-carousel-two {
                padding-top: $spacer-three;
            }

            .cta-group-header {
                padding: 0 $spacer-four $spacer-three;
            }
        }
    }
}
</style>
